export const loadingMessages = [
  "We're analyzing your listing against the 15 intent questions Amazon COSMO uses to rank products.",
  "Evaluating core usage & capability signals (used_for, capable_of)...",
  "Checking product identity & role clarity (is_a, used_as)...",
  "Assessing contextual signals — when, where, and conditions of use...",
  "Analyzing audience & persona alignment (used_by, used_for_aud)...",
  "Reviewing compatibility & pairing signals (used_with)...",
  "You'll see exactly which COSMO questions your listing answers well and where it falls short.",
  "Generating strategic recommendations for listings, A+ content, and brand stores...",
  "Compiling your Amazon AI Score...",
];
